exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.input-box-wrapper[data-v-4807f23d] {\n  position: relative;\n}\n.fake-input-wrapper[data-v-4807f23d] {\n  position: absolute;\n}\n", ""]);

